// extracted by mini-css-extract-plugin
export default {"img2":"Gallery_img2__IAFvZ","resizedImage":"Gallery_resizedImage__mgk4k","img3":"Gallery_img3__ct+e5"};